<template>
    <div></div>
</template>

<script>
    import { logout, post } from '@/utils/Http';
    import moment from 'moment';

    export default {
        name: 'ExtendSession',
        props: {
            userSessionDuration: {
                type: Number,
                required: true,
            },
            userSessionLastAccessed: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                startTimeoutId: null,
                expiryAlertTimeoutMS: 300000, // 5 minute warning (300 seconds)
            };
        },
        watch: {
            userSessionDuration: {
                handler(newVal, oldVal) {
                    if (newVal !== oldVal && newVal > oldVal) {
                        this.resetTimer();
                    }
                },
            },
            userSessionLastAccessed: {
                handler(newVal, oldVal) {
                    if (newVal !== oldVal && newVal) {
                        this.resetTimer();
                    }
                },
            },
        },
        created() {
            this.resetTimer();
        },
        methods: {
            // How much time in milliseconds has elapsed since last session access/refresh
            calculateTimeDiff() {
                let sessionStartDate = new Date(this.userSessionLastAccessed);
                return Math.abs(sessionStartDate - Date.now());
            },

            resetTimer() {
                if (this.startTimeoutId) {
                    clearTimeout(this.startTimeoutId);
                    this.startTimeoutId = null;
                }
                if (this.userSessionLastAccessed && !this.startTimeoutId) {
                    this.setTimerForSessionExpiry(this.calculateTimeDiff());
                }
            },

            refreshSession() {
                post('user/refreshSession', {}, this.resetTimer);
            },

            setTimerForSessionExpiry(timeDiff) {
                this.startTimeoutId = setTimeout(() => {
                    // Logout user if they do not respond to confirmation
                    const sessionExpiryTimer = setTimeout(() => {
                        logout(this.$router);
                    }, this.expiryAlertTimeoutMS);

                    let sessionEndDate = new moment(this.userSessionLastAccessed).add(
                        this.userSessionDuration,
                        'seconds',
                    );

                    this.$confirm(
                        this.$t('Your current session will end at [x]').replace(
                            /\[x]/g,
                            sessionEndDate.format('YYYY-MM-DD HH:mm:ss'),
                        ),
                        this.$t('Confirm'),
                        {
                            confirmButtonText: this.$t('Extend Session'),
                            cancelButtonText: this.$t('LOGOUT'),
                            type: 'warning',
                        },
                    )
                        .then(() => {
                            clearTimeout(sessionExpiryTimer);
                            this.refreshSession();
                        })
                        .catch(() => {
                            clearTimeout(sessionExpiryTimer);
                            logout(this.$router);
                        });
                }, this.userSessionDuration * 1000 - timeDiff - this.expiryAlertTimeoutMS);
            },
        },
    };
</script>
